import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropeSeasonSetsListData, autoEuropeSeasonSetsIsLoading } from "Pages/AutoEuropeTool/SeasonSets/@signals"

const SEASON_SETS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets`

export default function useAutoEuropeSeasonSetsTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			autoEuropeSeasonSetsIsLoading.value = true
			autoEuropeSeasonSetsListData.value = []
		})
		getSubmit(`${SEASON_SETS_API}/list`)
			.then(data => {
				batch(() => {
					autoEuropeSeasonSetsListData.value = data
					autoEuropeSeasonSetsIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropeSeasonSetsIsLoading.value = false
				showToast.error("Error loading season sets")
			})
	}, [])

	return { getTableData }
}
